import { PublicClientApplication } from '@azure/msal-browser';
import {
  ONE_DRIVE_AZURE_CLIENT_ID,
  THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_INVOICES,
  ONE_DRIVE_AZURE_TENANT_ID,
} from '../constants/Constants';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: ONE_DRIVE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${ONE_DRIVE_AZURE_TENANT_ID}`,
    redirectUri: THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_INVOICES,
  },
});

export default msalInstance;
